import { BaseSchema, BlazeTableSchema } from '@blaze-shared/schema-domain';
import { Connection, UnionWorkflowNode, Workflow } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Union')
export class UnionNodeSchemaProvider extends SchemaProvider<UnionWorkflowNode> {
  override getSchemas(
    workflow: Workflow,
    node: UnionWorkflowNode,
    schemas: {
      input: Map<string | symbol, BaseSchema>;
      output: Map<string | symbol, BaseSchema>;
      allSchemas: Record<string, BaseSchema>;
      userSchema?: BlazeTableSchema | null;
      accountSchema?: BlazeTableSchema | null;
    },
    connections: Connection[],
  ): Map<string | symbol, BaseSchema> {
    const nodeSchemas = super.getSchemas(workflow, node, schemas, connections);
    const targetNodes = workflow.nodes.filter((n) => node.targetNodeIds.includes(n.id));

    const inputXSchema = targetNodes.map((targetNode) => schemas.output.get(targetNode.id) ?? null);

    inputXSchema.forEach((schema, index) => {
      if (schema) {
        nodeSchemas.set(`input${index + 2}`, schema);
      }
    });

    return nodeSchemas;
  }
}
